import { Alert, Container, Link, Typography } from "@mui/material";
import { NavigationAndFooterLayout } from "../layouts";
import { NextPageWithLayout } from "@cm-websites/common";
import { NextSeo } from "next-seo";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

export const ForAuthorsPage: NextPageWithLayout = () => (
  <React.Fragment>
    <NextSeo
      description="Du hast eine Idee für einen neuen Fall? Oder eine ganz andere Idee für ein Spiel oder Buch? Dann würden wir gerne davon hören."
      title="Informationen für Autoren | Culinario Mortale®"
    />
    <Container
      maxWidth="md"
      sx={{ pt: { xs: 12, sm: 14, lg: 16 }, pb: { xs: 8, sm: 10, lg: 14, xl: 16 } }}
    >
      <Typography variant="h1" sx={{ pb: 6 }}>
        Informationen für Autorinnen und Autoren
      </Typography>
      <Typography variant="body1" paragraph>
        Du hast eine Idee für einen neuen Fall? Oder eine ganz andere Idee für ein Spiel oder Buch? Dann
        würden wir gerne davon hören.
      </Typography>
      <Typography variant="body1" paragraph>
        Wir freuen uns über Einsendungen von Manuskripten und prüfen diese gewissenhaft. Bitte sei nicht
        enttäuscht, wenn wir dir absagen. Oftmals passen Geschichten nicht zu unseren programmatischen
        Plänen oder wir haben ein ähnliches Setting bereits veröffentlicht oder in der Entwicklung.
        Leider können wir in der Regel keine ausführliche Begründung / Kritik verfassen, wenn wir eine
        Einsendung ablehnen. Dafür bitten wir dich um Verständnis. Du kannst deine Einsendungen schicken
        an <Link href="mailto:redaktion@culinario-mortale.de">redaktion@culinario-mortale.de</Link>
      </Typography>

      <Typography variant="h2" sx={{ pt: 4, pb: 3 }}>
        Einsendung von Krimidinner-Ideen
      </Typography>
      <Typography variant="body1" paragraph>
        Solltest du uns eine Idee für ein Krimidinner schicken wollen, dann achte bitte darauf, dass
        deine Idee zu unserem Spielkonzept und unserem Aufbau passt. Alle seriösen Anbieter von
        Krimidinnern unterscheiden sich deutlich in ihrem Konzept bzw. ihrer Umsetzung voneinander.
      </Typography>

      <Typography variant="body1" paragraph>
        Darüber hinaus würden wir dich bitten, folgende Punkte zu beachten:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1" paragraph>
            Bitte teile uns mit, für wieviele Personen der Fall ist (inkl. Geschlechterverteilung).
          </Typography>
        </li>
        <li>
          <Typography variant="body1" paragraph>
            Bitte teile uns auch deinen Arbeitsstand mit: Handelt es sich um ein Exposé oder ein fertiges
            Manuskript? Hast du den Fall bereits getestet?
          </Typography>
        </li>
        <li>
          <Typography variant="body1" paragraph>
            Falls es sich um ein fertiges Manuskript handelt: Bitte reiche uns in jedem Fall die{" "}
            <em>Aufklärung</em> und mindestens ein <em>Spielheft</em> ein, da wir sonst deine Idee nicht
            begutachten können. Idealerweise schickst du uns die Aufklärung und alle Spielhefte.
          </Typography>
        </li>
        <li>
          <Typography variant="body1" paragraph>
            Bitte sende dein Manuskript nicht gleichzeitig bei mehreren Verlagen ein. Das ist nicht
            verboten, aber wir (und auch die anderen Verlage) investieren viel Zeit und Ressourcen in das
            Lesen und Begutachten von eingereichten Manuskripten. Wir begegnen unseren AutorInnen mit
            Fairness und Respekt und erwarten dies auch von unserem Gegenüber.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" sx={{ pt: 4, pb: 3 }}>
        Einsendung anderer Ideen
      </Typography>
      <Typography variant="body1" paragraph>
        Du hast eine Idee für ein anderes Spiel oder Erlebnis aus dem Bereich Krimi oder ein Konzept für
        ein neues kooperatives Spiel? Dann überrasche uns – wir sind offen für neue Einfälle. Bitte stell
        uns deine Idee kurz vor und schicke uns alles, was du für das Verständnis für notwendig
        erachtest.
      </Typography>
      <Typography variant="body1" paragraph>
        Für uns zählt die Idee bzw. das Konzept. Wir erwarten nicht, dass du mit einem voll entwickelten,
        fertigem Spiel zu uns kommst. Viel lieber wollen wir mit dir zusammenarbeiten und Ideen gemeinsam
        weiterentwickeln. Bitte beachte, dass reguläre Brettspiele, egal aus welchem Genre, nicht zu
        unserem Programm passen.
      </Typography>
      <Alert severity="warning" icon={<InfoOutlinedIcon />}>
        Wir behandeln alle Manuskripte streng vertraulich – auch im Falle einer Absage. Sollten wir eine
        Idee aufnehmen wollen und in Abstimmung mit dir entwicklen wollen, nehmen wir Kontakt zu dir auf.
      </Alert>
      <Typography variant="body1" paragraph>
        Solltest du Fragen haben zu diesem Prozess oder wie eine Zusammenarbeit mit uns aussheen kann,
        dann zögere bitte nicht, uns zu{" "}
        <Link href="mailto:redaktion@culinario-mortale.de">kontaktieren</Link>. Viele Fragen lassen sich
        im persönlich Austausch schnell und einfach klären. Wenn du uns deine Telefonnummer schickst,
        rufen wir dich auch gerne zurück.
      </Typography>
    </Container>
  </React.Fragment>
);

ForAuthorsPage.getLayout = (page) => <NavigationAndFooterLayout>{page}</NavigationAndFooterLayout>;

export default ForAuthorsPage;
